export const CITY_STATUS_LABELS = {
  planned: "Planificada",
  research: "Investigación",
  dealer_acquisition: "Adquisición dealers",
  inventory_building: "Inventario",
  seo_preparation: "Preparación SEO",
  soft_launch_ready: "Lista soft launch",
  soft_launch: "Soft launch",
  active: "Activa",
  paused: "Pausada",
  archived: "Archivada",
};

export const LAUNCH_STAGE_LABELS = {
  not_started: "No iniciado",
  city_research: "Research ciudad",
  dealer_pipeline: "Pipeline dealers",
  inventory_collection: "Recolección inventario",
  inventory_cleanup: "Limpieza inventario",
  seo_setup: "Setup SEO",
  campaign_setup: "Setup campañas",
  launch_readiness: "Readiness launch",
  soft_launch: "Soft launch",
  full_launch: "Full launch",
  post_launch_optimization: "Optimización post-launch",
};

export const READINESS_LABELS = {
  not_ready: "No listo",
  needs_supply: "Necesita supply",
  needs_inventory_cleanup: "Limpieza inventario",
  needs_seo: "Necesita SEO",
  needs_campaigns: "Necesita campañas",
  soft_launch_ready: "Soft launch listo",
  full_launch_ready: "Full launch listo",
  active: "Activo",
};

export function slugifyCityInput(name) {
  return String(name || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}
